import { createInterfaceId } from "@gitlab/needle";
import { get } from "lodash-es";
//#region src/types.ts
const Logger = createInterfaceId("Logger");
//#endregion
//#region src/utils/with_prefix.ts
const LOG_METHODS = [
	"debug",
	"error",
	"info",
	"warn"
];
function withPrefix(logger, prefix) {
	const addPrefix = (message) => `${prefix} ${message}`;
	return LOG_METHODS.reduce((acc, method) => {
		acc[method] = (message, e) => {
			if (typeof message === "string") logger[method](addPrefix(message), e);
			else logger[method](message);
		};
		acc.withContext = (ctx) => {
			return withPrefix(logger.withContext(ctx), prefix);
		};
		return acc;
	}, {});
}
//#endregion
//#region src/null_logger.ts
var NullLogger = class {
	debug() {}
	info() {}
	warn() {}
	error() {}
	withContext() {
		return this;
	}
};
//#endregion
//#region src/test_logger.ts
var TestLogger = class {
	#ctx;
	#debugLogs = [];
	#infoLogs = [];
	#warnLogs = [];
	#errorLogs = [];
	#makeEntry(message, error) {
		return typeof message === "string" ? {
			message,
			error,
			ctx: this.#ctx
		} : {
			error: message,
			ctx: this.#ctx
		};
	}
	debug(message, error) {
		this.#debugLogs.push(this.#makeEntry(message, error));
	}
	info(message, error) {
		this.#infoLogs.push(this.#makeEntry(message, error));
	}
	warn(message, error) {
		this.#warnLogs.push(this.#makeEntry(message, error));
	}
	error(message, error) {
		this.#errorLogs.push(this.#makeEntry(message, error));
	}
	withContext(ctx) {
		this.#ctx = ctx;
		return this;
	}
	clear() {
		this.#debugLogs = [];
		this.#infoLogs = [];
		this.#warnLogs = [];
		this.#errorLogs = [];
	}
	get debugLogs() {
		return this.#debugLogs;
	}
	get infoLogs() {
		return this.#infoLogs;
	}
	get warnLogs() {
		return this.#warnLogs;
	}
	get errorLogs() {
		return this.#errorLogs;
	}
	get nonDebugLogs() {
		return [
			...this.#infoLogs,
			...this.#warnLogs,
			...this.#errorLogs
		];
	}
};
//#endregion
//#region src/log_context.ts
const logCtxItem = (name, value) => ({
	name,
	value
});
const logCtxParent = (name, ...children) => ({
	name,
	children: children.filter((ch) => ch !== void 0)
});
/** if multiple context parameters are defined, we join them otherwise we return a single context or undefined */
const joinContextsIfDefined = (name, ...contexts) => {
	const definedContexts = contexts.filter((c) => c !== void 0);
	if (definedContexts.length === 0) return void 0;
	if (definedContexts.length === 1) return definedContexts[0];
	return logCtxParent(name, ...definedContexts);
};
//#endregion
//#region src/context_error.ts
const isContextError = (error) => Boolean(get(error, "ctx.name"));
const getCtx = (error) => isContextError(error) ? error.ctx : void 0;
//#endregion
//#region src/log_level.ts
const LOG_LEVEL = {
	DEBUG: "debug",
	INFO: "info",
	WARNING: "warning",
	ERROR: "error"
};
const LogLevelProvider = createInterfaceId("LogLevelProvider");
//#endregion
//#region src/log_writer.ts
const LogWriter = createInterfaceId("LogWriter");
//#endregion
export { isContextError as a, logCtxParent as c, withPrefix as d, Logger as f, getCtx as i, TestLogger as l, LOG_LEVEL as n, joinContextsIfDefined as o, LogLevelProvider as r, logCtxItem as s, LogWriter as t, NullLogger as u };

//# sourceMappingURL=log_writer-6NTRwqhf.mjs.map